<template>
  <div>
    <h1>Productos de cortesía</h1>
    <div class="card">
      <div class="card-body">
        <div v-for="(provider, pIdx) in providers" :key="pIdx">
          <h4>
            Proveedor: <b>{{ provider.firstName }}</b>
          </h4>
          <div class="row">
            <div v-for="(product, idx) in provider.products" :key="idx" class="col-6 col-md-3">
              <div
                class="card mb-3"
                @click="productSelect(pIdx, idx)"
                :class="{'card-primary': product.selected}"
                style="border: 1px solid #ddd; cursor: pointer"
              >
                <div class="card-img" style="position: relative;">
                  <span v-if="product.selected" class="product-check">
                    <i class="material-icons">check_circle</i>
                  </span>
                  <img
                    :src="product.images.full.url || 'https://via.placeholder.com/500x500?text=No+Image'"
                    :alt="product.name" class="img-fluid"
                  >
                </div>
                <div class="card-footer">
                  <h5>{{ product.name }}</h5>
                </div>
              </div>
            </div>
          </div>
          <hr>
        </div>
        <div class="text-right">
          <button
            @click="$emit('go-back')"
            type="button"
            class="btn btn-default btn-lg mr-5"
          >
            Regresar
          </button>
          <button
            @click="generateCourtesy()"
            type="button"
            :disabled="!productSelected.provider || loading"
            class="btn btn-primary btn-lg"
          >
            {{ loading ? 'Generando...' : 'Generar cortesía' }}
          </button>
        </div>
        <div class="text-right text-danger" v-if="errors.generatingQr">
          {{ errors.generatingQr }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api';

export default {
  data() {
    return {
      loading: false,
      event: {},
      user: {},
      providers: [],
      errors: {
        generatingQr: '',
      },
    };
  },
  computed: {
    productSelected() {
      if (!this.providers.length) return {};
      const prov = this.providers.find(el => el.selected);
      if (!prov) return {};
      const prod = prov.products.find(el => el.selected);
      return {
        provider: prov,
        product: prod,
      };
    },
  },
  methods: {
    init(data) {
      this.event = data.event;
      this.user = data.user;
      this.providers = data.providers;
    },
    setError(key) {
      setTimeout(() => {
        this.errors[key] = '';
      }, 5000);
    },
    productSelect(pIdx, idx) {
      this.providers.map((el) => {
        this.$set(el, 'selected', false);
        el.products.map((product) => {
          this.$set(product, 'selected', false);
          return product;
        });
        return el;
      });
      this.providers[pIdx].selected = true;
      this.providers[pIdx].products[idx].selected = true;
    },
    generateCourtesy() {
      const self = this;
      this.loading = true;
      const { token } = this.$store.state.auth;
      const payload = {
        eventId: this.event.activity_id,
        sessionId: token, // usuario vendedor
        user: {
          email: this.user.email,
          document: this.user.document,
          documentType: this.user.documentType,
        },
        product: {
          providerId: this.productSelected.provider.id,
          productId: this.productSelected.product.id,
        },
      };
      const url = `${api.checkoutUrl}/generate/code/courtesy`;
      api.axios.post(url, { data: payload }).then((res) => {
        self.loading = false;
        if (!res.data.success) {
          self.errors.generatingQr = 'Error, inténtalo de nuevo!';
          self.setError('generatingQr');
          return;
        }
        self.$emit('on-success', {
          data: res.data,
          productName: this.productSelected.product.name,
        });
      }).catch(() => {
        self.loading = false;
        self.errors.generatingQr = 'Error, inténtalo de nuevo!';
        self.setError('generatingQr');
      });
    },
  },
};
</script>

<style lang="scss">
.product-check{
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0, 0.5);
  i{
    color: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
